if (!customElements.get('luv-product-reel')) {
  customElements.define('luv-product-reel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      this.gallery = this.closest('media-gallery');
      if (!this.video || !this.gallery) return;
      this.initialized = true;
      this.inView = false;

      // Observe the actual slide, so swipes work even without a thumbnail click.
      // Start only on entry; a shopper's Pause or the video's end stays paused.
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        if (visible === this.inView) return;
        this.inView = visible;
        if (visible) this.startPlayback();
        else this.video.pause();
      }, { threshold: [0, 0.25] });
      this.observer.observe(this);

      this.onVisibilityChanged = () => {
        if (document.hidden) {
          this.resumeWhenVisible = !this.video.paused;
          this.video.pause();
        } else if (this.resumeWhenVisible && this.inView) {
          this.startPlayback();
          this.resumeWhenVisible = false;
        }
      };
      document.addEventListener('visibilitychange', this.onVisibilityChanged);

      // A shareable review link opens the exact slide; playback begins muted.
      if (['#dana-product-demo', '#dana-extender-demo'].includes(location.hash)) {
        customElements.whenDefined('media-gallery').then(() => {
          if (!this.isConnected) return;
          this.gallery.setActiveMedia(this.dataset.mediaId, false, false);
          this.gallery.scrollIntoView({ block: 'start' });
        });
      }
    }
    async startPlayback() {
      if (!this.isConnected || !this.inView || document.hidden) return;
      window.pauseAllMedia?.();
      if (this.video.ended) this.video.currentTime = 0;
      try {
        await this.video.play();
      } catch (error) {
        // Preserve an explicit unmute when allowed, with a muted autoplay fallback.
        if (error.name === 'NotAllowedError' && !this.video.muted && this.inView && !document.hidden) {
          this.video.muted = true;
          await this.video.play().catch(() => {});
        }
        // Native controls remain available if the browser blocks autoplay entirely.
      }
      if (!this.isConnected || !this.inView || document.hidden) this.video.pause();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChanged);
      this.video?.pause();
      this.initialized = false;
    }
  });
}

// Keep each configured demo slide and thumbnail in matching gallery positions.
(() => {
  const reorder = () => document.querySelectorAll('luv-product-reel[data-product-handle="great-head"], luv-product-reel[data-product-handle="gps"]').forEach(reel => {
    const gallery = reel.closest('media-gallery');
    if (!gallery) return;
    [reel.closest('.luv-product-reel-slide'), gallery.querySelector('.luv-product-reel-thumbnail')].forEach(item => {
      if (!item) return;
      const list = item.parentElement;
      const otherItems = Array.from(list.children).filter(child => child !== item && child.matches('li'));
      if (otherItems.length < 2) return;
      const target = reel.dataset.productHandle === 'gps' ? otherItems[2] : otherItems[otherItems.length - 2];
      if (item.nextElementSibling !== target) list.insertBefore(item, target);
      Array.from(list.children).filter(child => child.matches('li')).forEach((child, index) => {
        child.dataset.mediaPosition = index + 1;
      });
      list.closest('product-gallery, product-thumbnails')?.resetPages?.();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reorder, { once: true });
  else reorder();
  document.addEventListener('shopify:section:load', reorder);
})();
